export default "__VITE_ASSET__BjhXExHo__"